import { useState, type ReactNode, type ReactElement } from 'react';
import {
  List,
  ListItemIcon,
  ListItemText,
  Collapse,
  ListItemButton,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useSidebarState } from 'react-admin';

interface SubMenuProps {
  primaryText: string;
  leftIcon: ReactElement;
  children: ReactNode;
}

const SubMenu = ({ primaryText, leftIcon, children }: SubMenuProps) => {
  const [open, setOpen] = useState(true);
  const [sidebarOpen] = useSidebarState();

  return (
    <>
      <ListItemButton
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          paddingLeft: 2,
          color: 'text.secondary',
        }}
      >
        <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>
          {leftIcon}
        </ListItemIcon>
        {sidebarOpen && (
          <>
            <ListItemText
              primary={primaryText}
              primaryTypographyProps={{ fontSize: '0.875rem' }}
            />
            {open ? <ExpandLess /> : <ExpandMore />}
          </>
        )}
      </ListItemButton>
      <Collapse in={open && sidebarOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ pl: 2 }}>
          {children}
        </List>
      </Collapse>
    </>
  );
};

export default SubMenu;
